"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartButton = exports.CART_BUTTON_STYLE_TYPE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Badge = require("b2b-components/theme/components/Badge");
var _Button = require("b2b-components/theme/components/Button");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _Price = require("b2b-components/theme/components/Price");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
require("b2b-components/core/components/CartButton/CartButton.scss");
let CART_BUTTON_STYLE_TYPE = exports.CART_BUTTON_STYLE_TYPE = /*#__PURE__*/function (CART_BUTTON_STYLE_TYPE) {
  CART_BUTTON_STYLE_TYPE["default"] = "default";
  CART_BUTTON_STYLE_TYPE["minified"] = "minified";
  return CART_BUTTON_STYLE_TYPE;
}({});
const CartButton = _ref => {
  let {
    className,
    href,
    onClick,
    value,
    dataAttributes,
    productCount = 0,
    productCountLimit = 99,
    styleType = CART_BUTTON_STYLE_TYPE.default
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-CartButton', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), styleType === CART_BUTTON_STYLE_TYPE.default && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    size: _Button.BUTTON_SIZE.small,
    href: href,
    className: "cds-CartButton-Button",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Price.Price, {
    currency: "CHF",
    price: value || 0,
    size: _Price.PRICE_SIZE.small,
    className: "cds-CartButton-Price"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.cart,
    size: _Icon.ICON_SIZE.small,
    className: "cds-CartButton-Icon"
  })), styleType === CART_BUTTON_STYLE_TYPE.minified && /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    icon: _Icon.ICON_NAME.cart,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    href: href,
    onClick: onClick,
    className: "cds-CartButton-ButtonIcon"
  }), /*#__PURE__*/_react.default.createElement(_Badge.Badge, {
    size: _Badge.BADGE_SIZE.small,
    className: "cds-CartButton-Badge"
  }, productCount > productCountLimit ? `${productCountLimit}+` : productCount));
};
exports.CartButton = CartButton;
//# sourceMappingURL=CartButton.js.map